<template>
    <div class="page-timu">
        <div class="page-top">
            <el-button type="primary" icon="el-icon-plus" @click="handleCreate">
                {{ $t("table.add") }}
            </el-button>
        </div>
        <!-- 表格 -->
        <div class="page-table">
            <el-table v-loading="listLoading" :data="tableData" style="width: 100%" default-expand-all>
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <div class="table-con">
                            <!-- 单选 -->
                            <div class="dan-box" v-if="props.row.type == 1">
                                <div class="dan-item dis" v-for="(item, index) in props.row.option" :key="index">
                                    <span class="yuan"></span>
                                    <span>{{ item.name }}</span>
                                    <span class="tiao-desc">{{ item.skip_str }}</span>
                                </div>
                            </div>
                            <!-- 多选 -->
                            <div class="duo-box" v-if="props.row.type == 2">
                                <div class="dan-item dis" v-for="(item, index) in props.row.option" :key="index">
                                    <span class="fang"></span>
                                    <span>{{ item.name }}</span>
                                </div>
                            </div>
                            <!-- 填空 -->
                            <div class="tian-box" v-if="props.row.type == 3">
                                <div class="kuan"></div>
                            </div>
                            <div class="zhu" style="padding-left:30px;"
                                v-if="props.row.skip_str && props.row.skip_str != ''">※{{ props.row.skip_str }}</div>
                        </div>

                    </template>
                </el-table-column>
                <!-- <el-table-column prop="id" label="id" min-width="80" /> -->
                <el-table-column prop="sort" align="left" label="序号" min-width="80" />
                <el-table-column prop="name" align="center" label="题干" min-width="200" />
                <el-table-column align="center" label="类型" min-width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 1">单选</span>
                        <span v-if="scope.row.type == 2">多选</span>
                        <span v-if="scope.row.type == 3">填空</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="必填" min-width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.nullable == 1">否</span>
                        <span v-if="scope.row.nullable == 0">是</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="left" width="500" fixed="right">
                    <template slot-scope="scope">
                        <el-button @click="showEdit(scope.row.id)" style="background: #FD962B; border-color: #FD962B"
                            type="primary">
                            编辑
                        </el-button>
                        <el-button v-if="scope.row.type != 3" type="success" @click="toshowXuan(scope.row.id)">
                            选项配置
                        </el-button>
                        <el-button type="success" @click="toshowTiao(scope.row.id)">
                            跳题配置
                        </el-button>
                        <el-button type="success" v-if="scope.row.show_up != 0" @click="yidong(scope.row, 1)">
                            上移
                        </el-button>
                        <el-button type="success" v-if="scope.row.show_down != 0" @click="yidong(scope.row, 2)">
                            下移
                        </el-button>
                        <el-button type="danger" @click="delFun(scope.row.id)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 题目新增编辑 -->
        <el-drawer custom-class="custom-drawer" :visible.sync="showTimu" :close-on-press-escape="false"
            :wrapper-closable="false" :show-close="false" size="1000px">
            <!-- 头部 -->
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">{{ isEdit == 1 ? '编辑' : '新增' }}</div>
                    <i class="el-icon-circle-close close-btn pointer" @click="closeTimu" />
                </div>
            </template>
            <div class="custom-content">
                <!-- 选择内容 -->
                <el-form ref="ruleForm" :model="timuPs" :rules="rules" label-width="130px">
                    <!-- 新增时可修改 -->
                    <el-form-item label="题目类型" prop="type" v-if="isEdit == 0">
                        <el-select v-model="timuPs.type" clearable filterable placeholder="请选择题目类型">
                            <el-option v-for="item in tiTypeList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="题干" prop="name" v-if="timuPs.type && timuPs.type != ''">
                        <el-input v-model="timuPs.name" />
                    </el-form-item>
                    <el-form-item label="是否必填" v-if="timuPs.type && timuPs.type != ''" prop="isBitian">
                        <el-switch v-model="timuPs.isBitian" active-color="#13ce66"></el-switch>
                    </el-form-item>
                    <el-form-item label="最少选择" v-if="timuPs.type == '2'">
                        <el-input-number v-model="timuPs.min_select" :min="0" :max="100"></el-input-number>
                        <div class="zhu">注：0代表不限制</div>
                    </el-form-item>
                    <el-form-item label="最多选择" v-if="timuPs.type == '2'">
                        <el-input-number v-model="timuPs.max_select" :min="0" :max="100"></el-input-number>
                        <div class="zhu">注：0代表不限制</div>
                    </el-form-item>

                </el-form>
                <div class="fix-fotter">
                    <div class="default-btn pointer" @click="tijiao('ruleForm')">提交
                    </div>
                </div>
            </div>
        </el-drawer>
        <!-- 题目选项配置 -->
        <el-drawer custom-class="custom-drawer" :visible.sync="showXuan" :close-on-press-escape="false"
            :wrapper-closable="false" :show-close="false" size="1000px">
            <!-- 头部 -->
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">选项配置</div>
                    <i class="el-icon-circle-close close-btn pointer" @click="closeXuan" />
                </div>
            </template>
            <!-- 内容 -->
            <div class="custom-content">
                <div class="xuan-box">
                    <div class="xuanList">
                        <div class="xuan-title">已创建的选项</div>
                        <div class="xuan-item dis" v-for="(item, index) in xuanList" :key="index">
                            <i class="el-icon-remove"
                                style="color: red;font-size: 20px;padding: 0 10px;margin-right: 10px;cursor: pointer;"
                                @click="delXuan(item)"></i>
                            <el-input style="width: 500px;" v-model="item.name" placeholder="请输入选项内容"
                                readonly></el-input>
                            <el-input readonly style="width: 250px;margin:0 20px;" type="number" v-model="item.score"
                                placeholder="请输入分数"></el-input>
                            <div style="width: 230px;">
                                <el-button style="background: #FD962B; border-color: #FD962B" type="primary"
                                    @click="editXuan(2, item)">
                                    编辑
                                </el-button>
                                <el-button v-if="item.show_up == 1" type="success" @click="xuanYi(1, item)">
                                    上移
                                </el-button>
                                <el-button v-if="item.show_down == 1" type="success" @click="xuanYi(2, item)">
                                    下移
                                </el-button>
                            </div>

                            <!-- <el-button type="danger">
                                删除
                            </el-button> -->
                        </div>
                    </div>
                    <!-- 新增选项 -->
                    <div class="zeng" @click="editXuan(1)">
                        添加选项
                    </div>
                </div>

            </div>
        </el-drawer>
        <!-- 单个选项编辑新增 -->
        <el-dialog title="选项" :close-on-click-modal="false" :visible.sync="dialogVisible" width="30%">
            <div>
                <div style="line-height: 30px;">选项内容</div>
                <el-input type="textarea" show-word-limit maxlength="100" v-model="conXuan.name"
                    placeholder="请输入选项内容"></el-input>
            </div>
            <div>
                <div style="line-height: 30px;">分数</div>
                <el-input type="number" v-model="conXuan.score" placeholder="请输入分数"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button :loading="queLoading" type="primary" @click="xuanQue">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 跳题配置弹出 -->
        <el-drawer custom-class="custom-drawer" :visible.sync="showTiaoti" :close-on-press-escape="false"
            :wrapper-closable="false" :show-close="false" size="1000px">
            <!-- 头部 -->
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">跳题配置</div>
                    <i class="el-icon-circle-close close-btn pointer" @click="closeTiaoti" />
                </div>
            </template>
            <div class="custom-content">
                <el-form ref="ruleFormtiao" :model="tiaotiPs" :rules="rules" label-width="130px">
                    <el-form-item label="跳题方式" prop="skip_type">
                        <el-select v-model="tiaotiPs.skip_type" clearable filterable placeholder="请选择跳题方式">
                            <el-option v-for="item in tiaoType" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <!-- 直接跳 -->
                    <el-form-item label="下题题目" prop="skip_ti_id" v-if="tiaotiPs.skip_type == 2">
                        <el-select v-model="tiaotiPs.skip_ti_id" clearable filterable placeholder="请选择下题题目">
                            <el-option v-for="item in tiaoList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                    <!-- 按选项 -->
                    <div class="tiao-list" v-if="tiaotiPs.skip_type == 1">
                        <div class="tiao-item" v-for="(item, index) in tiaoXuanList" :key="index"
                            style="margin-bottom: 30px;">
                            <div class="tiao-title">{{ index + 1 }}、{{ item.name }}</div>
                            <el-form-item label="下题题目" prop="skip_ti_id">
                                <el-select v-model="item.skip_ti_id" clearable filterable placeholder="请选择下题题目">
                                    <el-option v-for="itema in tiaoList" :key="itema.id" :label="itema.name"
                                        :value="itema.id" />
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                </el-form>
                <div class="fix-fotter">
                    <div class="default-btn pointer" @click="toTiaoti('ruleFormtiao')">提交
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import timu from '@/api/tianzheng/timu'
export default {
    components: {
    },
    data() {
        return {
            listLoading: false,//表格加载中
            tableData: [],//题目表格数据
            tableLength: 0,//题目列表长度
            wenjuan_id: "",//问卷id
            tiId: "",//题id
            isEdit: 0,//0新增 1编辑
            showTimu: false,//题目编辑新增弹出
            rules: {
                name: [{
                    required: true,
                    message: '请输入题干',
                    trigger: 'blur'
                }],
                // isBitian: [
                //     { required: true, message: '请选择', trigger: 'change' }
                // ]
            },//必填
            tiTypeList: [{ id: 1, name: "单选" }, { id: 2, name: "多选" }, { id: 3, name: "填空" }],
            // 题目参数
            timuPs: {
                id: "",
                wenjuan_id: "",//问卷id
                sort: "",//序号
                type: "",//题型,1单选2多选3填空
                name: "",//题干
                isBitian: false,//是否必填
                nullable: 1,//是否可以空,1可为空0必填
                min_select: 0,//多选题最少选几个,默认0
                max_select: 0//多选题最多选几个,默认0
            },
            showXuan: false,//选项配置弹出
            xuanList: [],//选项列表
            xuanLength: 0,//选项长度
            // 新增编辑选项参数
            conXuan: {
                id: null, name: "", score: "", sort: "", ti_id: ""
            },
            dialogVisible: false,//单个选项编辑新增
            queLoading: false,//选项弹出提交加载
            // 跳题
            showTiaoti: false,//跳题弹出
            tiaoType: [{ id: 1, name: "按选项跳题" }, { id: 2, name: "无条件跳题" }],
            tiaoList: [],//跳题下拉选
            // 配置跳题参数
            tiaotiPs: {
                ti_id: "",//题id
                skip_type: "",//跳题类型,0不跳,1按选项跳,2直接跳
                skip_ti_id: 0,//直接跳的时候跳到哪个题
                skip_option: [],//按选项跳的时候,数组
                // skip_option: [{
                // name:"",
                //     id: 1,//选项id,
                //     skip_ti_id: 1//这个选项调到哪个题
                // }]
            },
            tiaoXuanList: [],//需要跳转的选项列表
        }
    },
    created() {
        this.wenjuan_id = this.$route.query.id;
        this.getList();//题目表格数据列表
    },
    methods: {
        // 跳题提交
        toTiaoti(formName) {
            let that = this;
            that.$refs[formName].validate(valid => {
                if (valid) {
                    that.tiaotiPs.ti_id = that.tiId;
                    // console.log("tiaotiPs", that.tiaotiPs);
                    // console.log("tiaoXuanList", that.tiaoXuanList);
                    if (that.tiaotiPs.skip_type == 1) {
                        // 按选项跳
                        let obj;
                        that.tiaotiPs.skip_option = [];
                        for (var i in that.tiaoXuanList) {
                            obj = {
                                name: "",
                                id: "",
                                skip_ti_id: 0
                            }
                            obj.id = that.tiaoXuanList[i].id;
                            obj.name = that.tiaoXuanList[i].name;
                            obj.skip_ti_id = that.tiaoXuanList[i].skip_ti_id;
                            that.tiaotiPs.skip_option.push(obj);
                        }
                    } else {
                        that.tiaotiPs.skip_option = [];
                    }
                    console.log("参数", that.tiaotiPs);
                    timu.setSkip(that.tiaotiPs).then(res => {
                        if (res.code == 200) {
                            that.$message.success(res.message);
                            that.showTiaoti = false;
                            that.getList()
                        }
                    })
                }
            })
        },
        // 跳题清空
        resetFormTiao() {
            this.tiaotiPs.skip_type = "";
            this.tiaotiPs.skip_ti_id = 0;
            this.tiaotiPs.skip_option = [];
        },
        // 点击跳题配置
        toshowTiao(id) {
            let that = this;
            this.showTiaoti = true;
            that.tiId = id;//题目id
            this.resetFormTiao();//清空
            timu.skipDetail({ ti_id: id }).then(res => {
                if (res.code == 200) {
                    that.tiaotiPs.skip_type = res.result.skip_type == 0 ? '' : res.result.skip_type;
                    that.tiaotiPs.skip_ti_id = res.result.skip_ti_id;
                    that.tiaotiPs.skip_option = res.result.skip_option;
                    that.tiaoXuanList = res.result.skip_option;
                }
            })
            timu.tiSelect({ ti_id: id }).then(res => {
                if (res.code == 200) {
                    that.tiaoList = res.result;
                }
            })
            timu.getOption({ ti_id: id }).then(res => {
                if (res.code == 200) {
                    // that.tiaoXuanList = res.result;
                    let list = res.result;
                    for (var i in list) {
                        list[i].skip_ti_id = 0;
                    }
                    that.tiaoXuanList = list;
                }
            })
        },
        // 跳题弹出关闭
        closeTiaoti() {
            this.showTiaoti = false;
            this.resetFormTiao();//清空
        },
        // 选项上下移动
        xuanYi(type, item) {
            // 1上移2下移
            if (type == 1 && item.show_up == 0) {
                this.$message.error("当前选项不可上移");
                return;
            }
            if (type == 2 && item.show_down == 0) {
                this.$message.error("当前选项不可下移");
                return;
            }
            this.$confirm('是否确定移动此选项?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                timu.sortOption({
                    id: item.id, type: type
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.message)
                        this.toshowXuan(this.tiId)
                    } else {
                        //     this.$message.error(res.message)
                    }
                })
            }).catch(() => {
            })
        },
        // 删除单个选项
        delXuan(item) {
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                timu.removeOption({
                    id: item.id
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.message)
                        this.toshowXuan(this.tiId)
                    } else {
                        // this.$message.error(res.message)
                    }
                })
            }).catch(() => {
            })
        },
        // 选项弹出点击确定
        xuanQue() {
            let that = this;
            that.queLoading = true;//确定按钮加载

            if (!that.conXuan.name || that.conXuan.name == '') {
                that.$message.error("请输入选项内容");
                that.queLoading = false;
                return;
            }
            // if (!that.conXuan.score || that.conXuan.score == '') {
            //   that.conXuan.score = 0;
            // }
            if (that.conXuan.score < 0) {
                that.$message.error("选项分数不可小于0");
                that.queLoading = false;
                return;
            }
            if (that.conXuan.id && that.conXuan.id != '') {
                // 编辑
                timu.editOption(that.conXuan).then(res => {
                    if (res.code == 200) {
                        that.$message.success(res.message);
                        that.dialogVisible = false;
                        that.toshowXuan(that.tiId);
                    } else {
                        that.queLoading = false;
                    }
                })
            } else {
                // 新增
                that.conXuan.sort = that.xuanLength * 1 + 1;//选项序号
                that.conXuan.ti_id = that.tiId;//题目id
                // 新增选项
                timu.addOption(that.conXuan).then(res => {
                    if (res.code == 200) {
                        that.$message.success(res.message);
                        that.dialogVisible = false;
                        that.toshowXuan(that.tiId);
                    } else {
                        that.queLoading = false;
                    }
                })
            }
        },
        // 选项点击新增编辑
        editXuan(type, item) {
            // 1新增2编辑
            this.queLoading = false;
            this.conXuan.name = '';
            this.conXuan.score = '';
            this.conXuan.sort = '';
            this.conXuan.ti_id = '';
            this.conXuan.id = null;
            if (type == 2) {
                // 编辑
                this.conXuan.id = item.id;
                this.conXuan.name = item.name;
                this.conXuan.score = item.score;
                this.conXuan.sort = item.sort;
                this.dialogVisible = true;
            } else {
                // 新增
                this.dialogVisible = true;
            }
        },
        // 点击选项配置
        toshowXuan(id) {
            let that = this;
            this.showXuan = true;
            that.tiId = id;//题目id
            this.resetFormXuan();//清空
            timu.getOption({ ti_id: id }).then(res => {
                if (res.code == 200) {
                    that.xuanList = res.result;
                    that.xuanLength = res.result.length;//选项长度
                    that.getList();//题目表格数据列表
                }
            })
        },
        // 选项清空
        resetFormXuan() {
            // this.xuanList=[];
            // this.xuanLength=0;
        },
        // 选项配置弹出关闭
        closeXuan() {
            this.showXuan = false;
            this.resetFormXuan();//清空
        },
        // 点击上移下移
        yidong(item, type) {
            // 方向,1上移,2下移
            if (type == 1 && item.show_up == 0) {
                this.$message.error("当前选项不可上移");
                return;
            }
            if (type == 2 && item.show_down == 0) {
                this.$message.error("当前选项不可下移");
                return;
            }
            this.$confirm('是否确定移动此题目?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                timu.sort({
                    id: item.id, type: type
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.message)
                        this.getList()
                    } else {
                        //     this.$message.error(res.message)
                    }
                })
            }).catch(() => {
            })
        },
        // 新增编辑题目提交
        tijiao(formName) {
            let that = this;
            that.$refs[formName].validate(valid => {
                if (valid) {
                    that.timuPs.wenjuan_id = that.wenjuan_id;
                    // 必填
                    if (that.timuPs.isBitian == true) {
                        that.timuPs.nullable = 0
                    } else {
                        that.timuPs.nullable = 1
                    }
                    if (that.isEdit == 1) {
                        // 编辑题目
                        console.log("that.timuPs", that.timuPs);
                        timu.edit(that.timuPs).then(res => {
                            if (res.code == 200) {
                                that.showTimu = false;
                                that.getList();
                                that.$message.success(res.message);
                            }
                        })

                    } else {
                        // 新增题目
                        that.timuPs.sort = that.tableLength * 1 + 1;//序号
                        console.log("that.timuPs", that.timuPs);
                        timu.create(that.timuPs).then(res => {
                            if (res.code == 200) {
                                that.showTimu = false;
                                that.getList();
                                that.$message.success(res.message);
                            }
                            // else{
                            //     that.$message.error(res.message);
                            // }
                        })
                    }
                }
            })
        },
        // 题目列表
        getList() {
            this.listLoading = true
            timu.list({ wenjuan_id: this.wenjuan_id }).then(res => {
                this.listLoading = false
                if (res.code == 200) {
                    this.tableData = res.result;
                    this.tableLength = res.result.length * 1;//题目列表长度
                }
            })
        },
        // 题目数据清空
        resetForm() {
            let that = this;
            that.timuPs.id = "";
            that.timuPs.wenjuan_id = "";
            that.timuPs.sort = "";
            that.timuPs.type = "";
            that.timuPs.name = "";
            that.timuPs.isBitian = false;
            that.timuPs.nullable = 1;
            that.timuPs.min_select = 0;
            that.timuPs.max_select = 0;
            if (that.$refs["ruleForm"]) {
                that.$refs["ruleForm"].resetFields();
            }
        },
        // 点击添加题目
        handleCreate() {
            let that = this;
            that.isEdit = 0;
            that.showTimu = true;
            that.resetForm()
        },
        // 点击编辑
        showEdit(id) {
            let that = this;
            that.isEdit = 1;
            that.showTimu = true;
            that.resetForm()
            that.tiId = id;//题id
            timu.detail({ id: id }).then(res => {
                if (res.code == 200) {
                    let info = res.result;
                    that.timuPs.id = info.id;
                    that.timuPs.wenjuan_id = info.wenjuan_id;
                    that.timuPs.sort = info.sort;
                    that.timuPs.type = info.type;
                    that.timuPs.name = info.name;
                    that.timuPs.nullable = info.nullable;
                    that.timuPs.min_select = info.min_select;
                    that.timuPs.max_select = info.max_select;
                    if (info.nullable == 1) {
                        that.timuPs.isBitian = false;
                    } else {
                        that.timuPs.isBitian = true;
                    }
                }
            })
        },
        // 点击删除
        delFun(id) {
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                timu.remove({
                    id: id
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.message)
                        this.getList()
                    } else {
                        // this.$message.error(res.message)
                    }
                })
            }).catch(() => {
            })
        },
        // 关闭弹层
        closeTimu() {
            this.showTimu = false;
            this.resetForm();//清空
        },
    },
}
</script>

<style scoped>
.page-timu {
    padding: 20px;
}

.page-timu .page-top {
    background: #fff;
    padding: 15px 18px;
    border-radius: 3px;
    margin-bottom: 10px;
}

.page-timu .page-table {
    padding: 24px 18px;
    background: #fff;
}

.zhu {
    color: red;
    margin-top: 5px;
    font-size: 14px;
}

.dis {
    display: flex;
    align-items: center;
}

.xuan-box {
    padding-left: 20px;
}

.zeng {
    /* color: cornflowerblue; */
    cursor: pointer;
    color: #fff;
    background: #e70012;
    width: 130px;
    text-align: center;
    line-height: 30px;
    border-radius: 5px;
    margin-top: 20px;
}

.xuan-title {
    font-size: 18px;
    padding-left: 10px;
    margin-bottom: 20px;
}

.xuan-item {
    margin-bottom: 10px;
}

.tiao-title {
    /* position: relative; */
    padding-left: 60px;
    font-size: 18px;
    margin-bottom: 10px;
}

/* .tiao-title::before{
    contain: "";
    position: absolute;
    width: 5px;
    height: 5px;
    border-radius: 5px;
    background: #e70012;
    top: 0;
    left: 0;
} */
.yuan {
    display: inline-block;
    width: 15px;
    height: 15px;
    border-radius: 100%;
    margin-right: 10px;
    border: 1px solid #ddd;
}

.fang {
    display: inline-block;
    width: 15px;
    height: 15px;
    border-radius: 2px;
    margin-right: 10px;
    border: 1px solid #ddd;
}

.dan-box {
    padding-left: 30px;
    font-size: 16px;
    line-height: 30px;
}

.duo-box {
    padding-left: 30px;
    font-size: 16px;
    line-height: 30px;
}

.tian-box {
    padding-left: 30px;
}

.kuan {
    width: 400px;
    height: 60px;
    border-radius: 2px;
    border: 1px solid #ddd;
}

.tiao-desc {
    color: orange;
}

.table-con {
    /* width: 500px; */
    /* max-height:150px; */
    /* overflow-y: auto; */
}

.page-table {
    max-height: calc(100vh - 260px);
    overflow-y: auto;
}
</style>
